import {
  formatPercentageValue,
  formatNormalNumber,
  createKpiTileItem,
} from '../../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { activeBusinessUnit, activeBusinessUnitDelta } =
      data.getUserAdoptionScorecard;
    return createKpiTileItem(
      "Active BU's",
      formatNormalNumber(activeBusinessUnit),
      activeBusinessUnitDelta
        ? {
            isPositiveValue: activeBusinessUnitDelta >= 0,
            text: formatPercentageValue(Math.abs(activeBusinessUnitDelta)),
            sideLabel: '',
            showArrow: Number(activeBusinessUnitDelta) !== 0,
          }
        : null
    );
  },
};
